module.exports = __webpack_public_path__ + "img/intrare_logo.6ee56320.png";